// extracted by mini-css-extract-plugin
export default {"dropdown":"LanguageDropdown--dropdown--6118b6","dropdownItem":"LanguageDropdown--dropdownItem--145aad","label":"LanguageDropdown--label--30bd62"};